import { useState, useEffect } from "react";
import "../../styles/moah-audit.scss";
import axios from "axios";
import MoahLogo from "../../images/emblemNewBlk.webp";
import Instructions from "./Intructions";
import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import BusinessTable from "./BusinessTable";
import Audit from "./Audit";

//BUSINESS TYPE DATA
const businessTypes = [
  "restaurant",
  "cafe",
  "bar",
  "store",
  "clothing_store",
  "gym",
  "beauty_salon",
  "hair_care",
  "car_dealer",
  "real_estate_agency",
  "dentist",
  "doctor",
  "spa",
  "jewelry_store",
  "furniture_store",
  "electronics_store",
  "pet_store",
  "travel_agency",
  "lawyer",
  "accounting",
];

const MoahAudit = () => {
  const { t } = useTranslation();
  const url = process.env.REACT_APP_URL;
  const [input, setInput] = useState("");
  const [lastInput, setLastInput] = useState("");
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [resultCount, setResultCount] = useState(0);
  const [error, setError] = useState("");
  const [amount, setAmount] = useState("");
  const [disable, setDisable] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const [showAudit, setShowAudit] = useState(false);
  const [language, setLanguage] = useState("en");
  const [audit, setAudit] = useState({});
  const [businessName, setBusinessName] = useState("");
  const [selectedBusinessType, setSelectedBusinessType] =
    useState("establishment");

  useEffect(() => {
    const storedLang = localStorage.getItem("i18nextLng");
    if (storedLang) {
      console.log(storedLang);
      i18n.changeLanguage(storedLang);
      setLanguage(storedLang);
    }
  }, []);

  const handleSearch = async () => {
    setAmount("");
    setDisable(true);
    setLoading(true);
    setError("");
    try {
      const amount = await axios.post(
        `${url}/audit/business-count-by-location`,
        { location: input }
      );
      setAmount(amount.data.message);

      const res = await axios.post(`${url}/audit/audits-by-location`, {
        location: input,
        language: language,
        type: selectedBusinessType,
      });

      const results = res.data.data || [];
      console.log(results);
      setBusinesses(results);
      setResultCount(results.length);
      setLastInput(input);
    } catch {
      setError(t("fetch_error"));
    } finally {
      setDisable(false);
      setLoading(false);
    }
  };

  const handleSearchTargetted = async () => {
    setAmount("");
    setDisable(true);
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${url}/audit/targeted-business-audit`, {
        businessName: businessName,
      });

      const results = res.data.data || [];
      setBusinesses(results);
      setResultCount(results.length);
    } catch {
      setError(t("fetch_error"));
    } finally {
      setDisable(false);
      setLoading(false);
    }
  };

  const handleReset = () => {
    setInput("");
    setBusinessName("");
    setBusinesses([]);
    setResultCount(0);
    setError("");
    setDisable(false);
    window.location.reload();
  };

  const getAudit = async (biz) => {
    console.log(biz);
    setShowAudit(true);
    await axios
      .post(`${url}/audit/get-audit`, {
        data: biz,
        language: language,
      })
      .then((res) => {
        console.log(res.data.data);
        setAudit(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="container">
      <div className="topbar">
        <h2>
          <img src={MoahLogo} />
          {t("moah-audit")}
        </h2>
        <button
          className="instructionsBtn"
          onClick={() => setShowInstructions(true)}
        >
          {t("instructions")}
        </button>
        <button className="resetBtn" onClick={handleReset}>
          {t("reset")}
        </button>
      </div>

      <div className="box">
        {/* SEARCH BY GEOGRAPHIC LOCATION */}
        <p>{t("enter_prompt")}</p>
        <div className="controls">
          <input
            type="text"
            placeholder={t("search_placeholder")}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            disabled={disable}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSearch();
            }}
          />
          <select
            value={selectedBusinessType}
            onChange={(e) => setSelectedBusinessType(e.target.value)}
          >
            <option value="establishment">All Types</option>
            {businessTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
          <button
            className="searchBtn"
            onClick={handleSearch}
            disabled={disable}
          >
            {t("search")}
          </button>
        </div>
        {/* SEARCH BY SPECIFIC BUSINESS NAME */}
        <p>{t("enter_prompt_targetted")}</p>
        <div className="controls">
          <input
            type="text"
            placeholder={t("search_placeholder_targetted")}
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            disabled={disable}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSearchTargetted();
            }}
          />
          <button
            className="searchBtn"
            onClick={handleSearchTargetted}
            disabled={disable}
          >
            {t("search")}
          </button>
        </div>

        {error && <p className="error">{error}</p>}
        {loading && (
          <div className="loader">
            <p>
              {amount} "{input}"...
            </p>
            <p>{t("loading_info")}</p>
            <div className="spinner"></div>
          </div>
        )}
        {!loading && amount === "Found 0 businesses with websites." && (
          <p>
            {t("no_results")} "{lastInput}"
          </p>
        )}
        {!loading && businesses.length > 0 ? (
          <>
            <h3>
              {resultCount} {t("found")}
            </h3>
            <table className="summaryTable">
              <thead>
                <tr>
                  <th>{t("business")}</th>
                  <th>{t("phone")}</th>
                  <th>{t("website")}</th>
                  <th>{t("address")}</th>
                  <th>{t("Audit")}</th>
                </tr>
              </thead>
              <tbody>
                {businesses.map((biz, index) => (
                  <BusinessTable biz={biz} idx={index} getAudit={getAudit} />
                ))}
              </tbody>
            </table>
          </>
        ) : null}
      </div>

      <Modal open={showInstructions}>
        <Instructions handleClose={setShowInstructions} />
      </Modal>
      <Modal open={showAudit}>
        <Audit
          handleClose={setShowAudit}
          audit={audit}
          language={language}
          open={showAudit}
        />
      </Modal>
    </div>
  );
};

export default MoahAudit;
